<template>
  <div class="chat-group-list">
    <!-- AI 报价-群管理（企业微信手机端，仅查看） -->
    <mobile-list-header>
      <div class="search-bar">
        <div class="search-input">
          <yq-icon class="icon" name="element-ui_search"/>
          <input v-model="searchInfo.searchKey" placeholder="群名称" @keyup.enter="resetSearch"/>
          <yq-icon v-if="searchInfo.searchKey" class="icon clear" name="element-ui_close" @click="clearKey"/>
        </div>
        <div class="search-btn" @click="resetSearch">搜索</div>
      </div>
    </mobile-list-header>

    <mobile-list :loading="loading" :has-more="searchInfo.hasMore" :query-list="queryList"
                 :refresh="resetSearch" ref="mobileList">
      <list-card class="group-item" v-for="item in dataList" :key="item.id" :label="item.groupName">
        <template #desc>
          <span class="status-tag" :class="Number(item.autoReply) === 1 ? 'on' : 'off'">
            {{ Number(item.autoReply) === 1 ? "自动报价" : "未开启" }}
          </span>
        </template>
        <data-column label="群聊人数">{{ item.memberCount || 0 }} 人</data-column>
        <data-column label="群主">{{ item.employeeName || "—" }}</data-column>
        <data-column label="创建时间">{{ dateTime(item.createdTime) }}</data-column>
      </list-card>
    </mobile-list>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import MobileList from "@/components/qywx/layout/MobileList.vue";
import MobileListHeader from "@/components/qywx/layout/MobileListHeader.vue";
import ListCard from "@/components/qywx/layout/ListCard.vue";
import DataColumn from "@/components/qywx/data/DataColumn.vue";
import YqIcon from "@/components/YqIcon.vue";
import qywxXbotGroupApi from "@/api/dz-ai/qywxXbotGroupApi";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "ChatGroupListQW",
  components: {
    YqIcon, DataColumn, ListCard, MobileListHeader, MobileList
  },
  data() {
    return {
      loading: false,
      searchInfo: {
        searchKey: "",
        pageNumber: 0,
        pageSize: 20,
        hasMore: true, // 初始为 true，列表挂载后由无限滚动自动触发首次查询
      },
      dataList: [],
    };
  },
  methods: {
    queryList() {
      this.loading = true;
      this.searchInfo.pageNumber++;
      qywxXbotGroupApi.queryList({
        searchKey: this.searchInfo.searchKey,
        pageNumber: this.searchInfo.pageNumber,
        pageSize: this.searchInfo.pageSize,
      }).then(res => {
        this.dataList = this.dataList.concat(res.records || []);
        this.searchInfo.hasMore = res.pageCount > this.searchInfo.pageNumber;
        this.loading = false;
        this.$refs.mobileList.hideRefreshTitle();
      }).catch(() => {
        this.loading = false;
      })
    },
    resetSearch() {
      this.searchInfo.pageNumber = 0;
      this.dataList = [];
      this.searchInfo.hasMore = true;
      this.queryList();
    },
    clearKey() {
      this.searchInfo.searchKey = "";
      this.resetSearch();
    },
    dateTime(value) {
      return value ? String(value).slice(0, 16) : "—";
    },
  }
};
</script>

<style lang="scss" scoped>
.chat-group-list{
  height: 100%;
  display: flex;
  flex-direction: column;
}
.search-bar{
  display: flex;
  align-items: center;
  height: 44px;
  padding-left: 12px;
  border-radius: 999px;
  background: var(--yq-background-color);
  overflow: hidden;
  .search-input{
    flex: 1;
    display: flex;
    align-items: center;
    min-width: 0;
    height: 100%;
    padding-right: 12px;
    .icon{
      flex: none;
      color: var(--yq-font-color-desc);
      font-size: var(--yq-font-size-mini-mobile);
      &.clear{
        margin-left: 6px;
      }
    }
    input{
      flex: 1;
      min-width: 0;
      height: 100%;
      margin-left: 6px;
      border: none;
      outline: none;
      background: transparent;
      font-size: var(--yq-font-size-mini-mobile);
      color: var(--yq-font-color-base);
      &::placeholder{
        color: var(--yq-font-color-desc);
      }
    }
  }
  .search-btn{
    flex: none;
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 18px;
    background: var(--el-color-primary);
    color: #FFF;
    font-size: var(--yq-font-size-mini-mobile);
  }
}
.group-item{
  .status-tag{
    flex: none;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: var(--yq-font-size-mini-mobile);
    &.on{
      color: var(--el-color-success);
      background: var(--el-color-success-light-9);
    }
    &.off{
      color: var(--el-color-info);
      background: var(--el-fill-color-light);
    }
  }
}
</style>
